<template>
<main class="container-1 assign-view">

    <div class="container-header">
        <MapDetailHeader :map="map" />
        <p class="assign-view__hint">Los cambios se guardan al instante.</p>
    </div>

    <!-- Filtro compartido: aplica a ambos paneles -->
    <div class="assign-filters">
        <input id="search" v-model="inputGeoprocessing" type="text" placeholder="Buscar geoproceso..." />
    </div>

    <div class="assign-panels">

        <!-- Panel: geoprocesos disponibles -->
        <section class="apanel">
            <header class="apanel__head">
                <strong>Disponibles</strong>
                <span class="apanel__count">{{ availableGeoprocessings.length }}</span>
            </header>

            <div class="apanel__body">
                <div
                v-for="item in availableGeoprocessings"
                v-bind:key="item.id"
                class="arow">
                    <input type="checkbox" class="arow__check" :checked="isSelected(selAvailable, item.id)" v-on:change="toggleSelection(selAvailable, item.id)" :aria-label="'Seleccionar ' + item.name" />
                    <span class="arow__info">
                        <b class="arow__name">{{ item.name }}</b>
                        <small v-if="item.geo_url" class="arow__file">{{ item.geo_url }}</small>
                    </span>
                    <button class="btn btn-primary btn-row" v-on:click="assignGeoprocessing(item)">+ Asignar</button>
                </div>

                <p v-if="!availableGeoprocessings.length" class="apanel__empty">No hay geoprocesos disponibles.</p>
            </div>

            <footer class="apanel__foot apanel__foot--between">
                <label class="apanel__selall">
                    <input type="checkbox" :checked="allSelected(availableGeoprocessings, selAvailable)" v-on:change="toggleSelectAll(selAvailable, availableGeoprocessings)" />
                    Seleccionar todos
                </label>
                <button class="btn btn-primary btn-row" :disabled="!selectedItems(availableGeoprocessings, selAvailable).length" v-on:click="assignSelected()">Asignar seleccionados ({{ selectedItems(availableGeoprocessings, selAvailable).length }})</button>
            </footer>
        </section>

        <!-- Panel: geoprocesos asignados -->
        <section class="apanel">
            <header class="apanel__head">
                <strong>Asignados al mapa</strong>
                <span class="apanel__count apanel__count--on">{{ assignedInView.length }}</span>
            </header>

            <div class="apanel__body">
                <div
                v-for="item in assignedInView"
                v-bind:key="item.id"
                class="arow">
                    <input type="checkbox" class="arow__check" :checked="isSelected(selAssigned, item.id)" v-on:change="toggleSelection(selAssigned, item.id)" :aria-label="'Seleccionar ' + item.name" />
                    <span class="arow__info">
                        <b class="arow__name">{{ item.name }}</b>
                        <small v-if="item.geo_url" class="arow__file">{{ item.geo_url }}</small>
                    </span>
                    <button class="btn btn-danger btn-row" v-on:click="unassignGeoprocessing(item)">Quitar</button>
                </div>

                <p v-if="!assignedInView.length" class="apanel__empty">Aún no hay geoprocesos asignados.</p>
            </div>

            <footer class="apanel__foot apanel__foot--between">
                <label class="apanel__selall">
                    <input type="checkbox" :checked="allSelected(assignedInView, selAssigned)" v-on:change="toggleSelectAll(selAssigned, assignedInView)" />
                    Seleccionar todos
                </label>
                <button class="btn btn-danger btn-row" :disabled="!selectedItems(assignedInView, selAssigned).length" v-on:click="unassignSelected()">Quitar seleccionados ({{ selectedItems(assignedInView, selAssigned).length }})</button>
            </footer>
        </section>

    </div>

</main>
</template>

<script>
// @ is an alias to /src
import MapDetailHeader from '@/components/MapDetailHeader.vue'
import {userGroupName} from '@/components/mixin/userGroupName.js'
import {assignSelection} from '@/components/mixin/assignSelection.js'

export default{
    name: 'test',
    mixins: [userGroupName, assignSelection],
    data(){
        return{
            map: '',

            allGeoprocessings: [],
            assignedGeoprocessings: [],

            inputGeoprocessing: '',
        }
    },
    components:{
        MapDetailHeader
    },
    computed: {
        // Geoprocesos que coinciden con la búsqueda (nombre o URL, blindado)
        matchedGeoprocessings: function() {
            var list = this.allGeoprocessings || [];
            var text = this.inputGeoprocessing.trim().toLowerCase();
            if (!text) {
                return list;
            }
            return list.filter(function(geo){
                var name = (geo.name || '').toLowerCase();
                var url = (geo.geo_url || '').toLowerCase();
                return name.indexOf(text) !== -1 || url.indexOf(text) !== -1;
            });
        },
        availableGeoprocessings: function() {
            return this.matchedGeoprocessings.filter(function(geo){ return !geo.isAssigned; });
        },
        assignedInView: function() {
            return this.matchedGeoprocessings.filter(function(geo){ return geo.isAssigned; });
        },
        routesBread: function(){
          return [
              {name:'Mapas', path: '/mapas' },
              {name: this.map.name, path: '/mapas/' + this.$route.params.idMap},
              {name: 'Asignar geoprocesos'}
              ]
        }
    },
    props: [],
    methods:{
        getMap: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap)
            .then(function (response) {
                that.map = response.data;
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAssignedGeoprocessings: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/geoprocessings') //Sin paginación
            .then(function (response) {
                that.assignedGeoprocessings = response.data;
                that.getAllGeoprocessings();
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAllGeoprocessings: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/geoprocessings') //Sin paginación
            .then(function (response) {
                that.allGeoprocessings = response.data;
                that.checkAlreadyAssignedGeoprocessings();
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        checkAlreadyAssignedGeoprocessings: function(){
            if(this.allGeoprocessings == null || this.assignedGeoprocessings == null) {
                //Si alguna está vacía, no es necesario ejecutar esta función
                return;
            }
            var assignedIndexInAll = [];
            for (let i = 0; i < this.assignedGeoprocessings.length; i++) {
                let index = this.allGeoprocessings.map(function(item){
                     return item.id;
                     }).indexOf(this.assignedGeoprocessings[i].id);
                assignedIndexInAll.push(index);
            }
            for (let i = 0; i < assignedIndexInAll.length; i++) {
                if(assignedIndexInAll[i] >= 0) {
                    this.allGeoprocessings[assignedIndexInAll[i]].isAssigned = true;
                }
            }
        },
        assignGeoprocessing: function(geoprocessing){
            var that = this;
            this.$http.post(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/geoprocessings/' + geoprocessing.id,
            {
                id_map: this.$route.params.idMap,
                id_geoprocessing: geoprocessing.id
            })
            .then(function (response) {
                that.getAssignedGeoprocessings();
            })
            .catch(function (error) {
                console.log(error);
                that.message = error.response.data.message;
            });
        },
        unassignGeoprocessing: function(geoprocessing){
            var that = this;
            this.$http.delete(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/geoprocessings/' + geoprocessing.id)
            .then(function (response) {
                that.getAssignedGeoprocessings();
            })
            .catch(function (error) {
                console.log(error);
                that.message = error.response.data.message;
            });
        },
        assignSelected: function(){
            var that = this;
            this.selectedItems(this.availableGeoprocessings, this.selAvailable).forEach(function(geoprocessing){
                that.assignGeoprocessing(geoprocessing);
            });
            this.selAvailable.splice(0);
        },
        unassignSelected: function(){
            var that = this;
            this.selectedItems(this.assignedInView, this.selAssigned).forEach(function(geoprocessing){
                that.unassignGeoprocessing(geoprocessing);
            });
            this.selAssigned.splice(0);
        }
    },
    updated () {

    },
    created () {
        this.$store.getters.getPermissions.maps? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getMap();
        this.getAssignedGeoprocessings();
    }
}
</script>

<style lang="scss" scoped>
.assign-view__title {
    margin: 0.2rem 0 0;
    font-size: 1.25rem;
    color: var(--color-navy);
}

.assign-view__hint {
    margin: 0.15rem 0 0;
    font-size: 0.78rem;
    color: var(--color-ghost);
}

.assign-filters {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin: 0.7rem 0 0.85rem;
}

.assign-filters select,
.assign-filters input {
    width: 100%;
    padding: 0.5em 0.7em;

    border: 1px solid var(--color-line);
    border-radius: 7px;
    background: var(--color-white);
    color: var(--color-graphite);

    font-family: inherit;
    font-size: 0.9rem;
}

.assign-filters select:focus,
.assign-filters input:focus {
    outline: none;
    border-color: var(--color-steel);
    box-shadow: 0 0 0 3px rgba(59, 110, 148, 0.15);
}

.assign-panels {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.9rem;
    align-items: start;
}

.apanel {
    display: flex;
    flex-direction: column;

    background: var(--color-white);
    border: 1px solid var(--color-line);
    border-radius: 10px;
    overflow: hidden;
}

.apanel__head {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    padding: 0.6rem 0.8rem;
    background: var(--color-mist);
    border-bottom: 1px solid var(--color-line);
}

.apanel__head strong {
    font-size: 0.9rem;
    color: var(--color-navy);
}

.apanel__count {
    margin-left: auto;
    min-width: 1.7em;
    padding: 0.05rem 0.5rem;

    border-radius: 999px;
    background: var(--color-steel);
    color: #fff;

    font-size: 0.72rem;
    font-weight: 700;
    text-align: center;
}

.apanel__count--on {
    background: var(--color-success);
}

.apanel__body {
    max-height: 52vh;
    overflow-y: auto;
}

.arow {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.5rem 0.7rem;
    transition: background-color 0.12s ease;
}

.arow + .arow {
    border-top: 1px solid var(--color-line);
}

.arow:hover {
    background: var(--color-mist);
}

.arow__info {
    flex: 1;
    min-width: 0;
}

.arow__name {
    display: block;
    font-size: 0.88rem;
    font-weight: 600;
    color: var(--color-navy);
    word-break: break-word;
}

.arow__file {
    font-size: 0.72rem;
    color: var(--color-ghost);
    font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
}

.apanel__foot {
    display: flex;
    justify-content: flex-end;

    margin-top: auto;
    padding: 0.6rem 0.7rem;
    border-top: 1px solid var(--color-line);
}

.apanel__empty {
    margin: 0;
    padding: 2rem 1rem;
    text-align: center;
    color: var(--color-ghost);
    font-style: italic;
}

.btn-row {
    padding: 0.32em 0.8em;
    font-size: 0.8rem;
}

.arow__check {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    accent-color: var(--color-steel);
    cursor: pointer;
}

.apanel__foot--between {
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
}

.apanel__selall {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.76rem;
    color: var(--color-graphite);
    cursor: pointer;
    white-space: nowrap;
}

.apanel__selall input {
    accent-color: var(--color-steel);
    cursor: pointer;
}

@media only screen and (max-width: 760px) {
    .assign-panels {
        grid-template-columns: 1fr;
    }
}
</style>
